import React from 'react';
import { siteConfig } from '../data/config';
import { FaInstagram, FaYoutube, FaTiktok, FaAt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import useScrollEffect from '../hooks/useScrollEffect';
const socialIcons = {
    instagram: FaInstagram,
    youtube: FaYoutube,
    tiktok: FaTiktok,
    thread: FaAt  // Using @ symbol for Threads
};

const Header = ({ name, tagline, height="30vh", disabled=false, centered=false, scrollEffect=false }) => {
    const headerStylesScrollEffect = useScrollEffect();

    const headerStyle = {
        height: height,
        minHeight: height
    };

    if (centered) {
        headerStyle.display = 'flex';
        headerStyle.justifyContent = 'center';
        headerStyle.alignItems = 'center';
    }

    if (scrollEffect) {
        Object.assign(headerStyle, headerStylesScrollEffect);
    }

    return (
        <header className="header" style={headerStyle}>
            <div className="container header-content">
                <h1>
                    <Link to="/" className={`home-link ${disabled ? 'disabled' : ''}`}>
                        {name}
                    </Link>
                </h1>
                <nav className="social-links">
                    {Object.entries(siteConfig.socialLinks).map(([platform, url]) => {
                        const Icon = socialIcons[platform];
                        return (
                            <a 
                                key={platform} 
                                href={url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="social-link"
                            >
                                <Icon />
                            </a>
                        );
                    })}
                </nav>
            </div>
        </header>
    );
};

export default Header;